export const AUDIENCES_OBJECT_TYPE = '0-156';
export const OBJECT_NAMES = {
  AUDIENCE: 'AUDIENCE',
  CALL_TO_ACTION: 'CALL_TO_ACTION'
};
export const AUDIENCE_CRM_PROPERTIES = {
  NAME: 'hs_audience_name',
  DESCRIPTION: 'hs_description',
  ID: 'hs_saved_audience_id',
  LAST_MODIFIED: 'hs_lastmodifieddate',
  LAST_MODIFIED_BY: 'hs_updated_by_user_id',
  CREATED: 'hs_createdate',
  CREATED_BY: 'hs_created_by_user_id',
  OBJECT_ID: 'hs_object_id',
  MERGED_OBJECT_IDS: 'hs_merged_object_ids',
  PUBLISHED_BY: 'hs_published_by_user_id',
  DELETED_BY: 'hs_deleted_by_user_id',
  IS_REUSABLE: 'hs_is_reusable',
  OWNER_ASSIGNED_DATE: 'hubspot_owner_assigneddate',
  RECORD_SOURCE: 'hs_object_source_label',
  RECORD_SOURCE_1: 'hs_object_source_detail_1',
  RECORD_SOURCE_2: 'hs_object_source_detail_2',
  RECORD_SOURCE_3: 'hs_object_source_detail_3',
  OWNER: 'hubspot_owner_id',
  TEAM_ID: 'hubspot_team_id'
};
export const CRM_PROPERTIES = Object.values(AUDIENCE_CRM_PROPERTIES);